import template from './brands.html';
import controller from './brands.controller';

let brandsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default brandsComponent;
